import React from 'react';
import { observer } from 'mobx-react';
import { PodcastEpisodeStore } from '@seedlang/stores';
import { isPresent } from '@seedlang/utils';
import { AppUI } from '@seedlang/state';
import Stack from 'components/layout/stack';
import ButtonPrimary from 'components/button/button_primary';

@observer
class PodcastEpisodeCreate extends React.Component {

  onClick() {
    if (isPresent(this.refs.title.value)) {
      const data = {
        title: this.refs.title.value,
        siteId: AppUI.site.id,
      };
      PodcastEpisodeStore.create({data: data}, this.props.afterCreate);
      this.refs.title.value = '';
    }
  }

  render() {
    return (
      <Stack inline gap='sm'>
        <input
          placeholder='Add a title'
          ref='title'
          style={{width: '100%'}}
        />
        <ButtonPrimary onClick={this.onClick.bind(this)}>
          Create
        </ButtonPrimary>
      </Stack>
    );
  }
}

export default PodcastEpisodeCreate;
